import { TextField } from '@mui/material';
import { amountHint } from './parseAmount';

/**
 * Campo de MONTO escrito a mano (pesos, UF, UTM). Reemplaza a los
 * `<TextField type="number">` del ERP (2026-09-29): el input numérico del
 * navegador leía "600.000" como 600 y no dejaba escribir coma. Aquí es un
 * campo de texto con teclado decimal; el valor crudo se guarda tal cual en el
 * estado del formulario y se convierte con `parseAmount` al armar el payload
 * (formato chileno: punto de miles, coma decimal). Mientras el texto trae
 * separadores muestra cómo se entendió: "= 600.000".
 */
const ErpAmountField = ({ value, helperText, inputProps, ...props }) => {
  const hint = amountHint(value);
  const helper = hint ? (helperText ? `${helperText} · ${hint}` : hint) : helperText;
  return (
    <TextField
      fullWidth
      size="small"
      value={value ?? ''}
      inputProps={{ inputMode: 'decimal', ...(inputProps || {}) }}
      helperText={helper}
      {...props}
    />
  );
};

export default ErpAmountField;
